import React from "react";
import { useTranslation } from "react-i18next";
import { Toast, ToastContainer } from "react-bootstrap";

interface ToastSuccessProps {
    show: boolean;
    message: string;
    onClose: () => void;
    delay?: number;
}

const ToastSuccess: React.FC<ToastSuccessProps> = ({ show, message, onClose, delay = 3000 }) => {
    const { t } = useTranslation("common");

    return (
        <ToastContainer position="top-end" className="p-3">
            <Toast onClose={onClose} show={show} delay={delay} autohide bg="success">
                <Toast.Header>
                    <strong className="me-auto">{t("toast.success.title")}</strong>
                </Toast.Header>
                <Toast.Body className="text-white">{message}</Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default ToastSuccess;
